import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const FeatureCard = ({ data }) => {
    const navigate = useNavigate();
    const [limit] = useState(9);

    const handleNavigate = (path) => {
        navigate(`/search-result/trip/${path}`, {
            state: { limit }
        });
    };
    return (
        <>
            {data.slice(0, -1).map((item) => (
                <div onClick={() => handleNavigate(item.title)} key={item.id} className='feature'>
                    <img src={item.image} alt={item.title} loading='lazy' decoding='async' />
                    <span className='featureCount'>{item.count} Tours</span>
                    <span className='featureTitle'>{item.title}</span>
                </div>
            ))}
        </>
    );
};

export default FeatureCard;
